import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_SCENARIOASSET_REGISTRY_KEY, META_TYPE, META_VER } from './scenarioAssetCommandRegisteryType';

/**
 * Registers the /scenario command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /scenario assets — opens the ScenarioAssetWidget card.
 */
export function registerScenarioAssetCommand() {
    commandEngine.register('/scenario', {
        hint: 'Open scenario assets',
        params: [{ name: 'view', options: [{ label: 'Assets', value: 'assets' }] }],
        handler: () => {
            cardPainterManager.openCard(CMD_SCENARIOASSET_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
